import { render } from "./BaseTitle.vue?vue&type=template&id=3c78a568"
const script = {}

import exportComponent from "C:\\Users\\rizki\\OneDrive - OneDrive\\Documents\\UPI\\SEMESTER_5\\Kualitas Perangkat Lunak\\project-cephat\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__